import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';

import styles from './styles.css';

export default function ComparisonValue({ value, comparisonValue, renderComparisonValue, competitiveIndex }) {
  const getCssClass = () => {
    if (competitiveIndex && (value === 0 || comparisonValue === 0)) {
      return styles.unavailable;
    }
    if (value > comparisonValue) {
      return styles.higher;
    }
    if (value < comparisonValue) {
      return styles.lower;
    }
    return styles.equal;
  };

  const getCaret = () => {
    if (competitiveIndex && value === 0) {
      return null;
    }
    if (value !== comparisonValue) {
      return <FontAwesomeIcon icon={value > comparisonValue ? faCaretUp : faCaretDown} className={styles.statCaret} />;
    }
    return null;
  };

  const showComparisonValue = () => {
    if (competitiveIndex && value === 0) {
      return 'N/A';
    }
    return renderComparisonValue ? renderComparisonValue(Math.abs(value - comparisonValue)) : Math.abs(value - comparisonValue);
  };


  return (
    <td className={`${styles.statComparison} ${getCssClass()}`}>
      <span>
        {showComparisonValue()}
        {getCaret()}
      </span>
    </td>
  );
}

ComparisonValue.propTypes = {
  value: PropTypes.number,
  comparisonValue: PropTypes.number,
  renderComparisonValue: PropTypes.func,
  competitiveIndex: PropTypes.bool,
};

ComparisonValue.defaultProps = {
  value: 0,
  comparisonValue: 0,
  renderComparisonValue: null,
  competitiveIndex: false,
};
